import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { WorkplaceActivityDto } from '../../services/activity.service';

@Pipe({
    name: "filterByWorkplaceId"
})
@Injectable()
export class FilterByWorkplaceIdPipe implements PipeTransform {
    transform(items: WorkplaceActivityDto[], workplaceId?: number): any {
        if (!items || !workplaceId) {
            return items;
        }

        // Filter by workplace ID
        return items
            .filter(item => item.Workplace.Id === workplaceId);
    }
}

@Pipe({
    name: "filterByWorkgroup"
})
@Injectable()
export class FilterByWorkgroupPipe implements PipeTransform {
    transform(items: Nema.Crew.Model.Activity[], workGroup?: Nema.Crew.Model.WorkGroup): any {
        if (!items || !workGroup) {
            return items;
        }

        // Filter by Workgroup
        return items
            .filter(item => workGroup.WorkGroupPersons
                .findIndex(x => x.PersonId === item.PersonId) > -1);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/daily-activities/activity-filter-by.pipes.ts